import { ATTACHMENT_KIND, SHEET_SECTION, STAGE } from './sheet-sections.js';
import { isSewingThread } from './trim-units.js';
const numberPresent = (v) => v != null && v.trim() !== '' && Number.isFinite(Number(v));
export function baselineSizesReady(rows) {
    return rows.length > 0 && rows.every((r) => Boolean(r.patternPartCd?.trim() || r.patternPartNm?.trim())
        && (numberPresent(r.size) || r.values.some((v) => numberPresent(v.value))));
}
export function sizeDeviationsReady(rows) {
    const optionalNumber = (value) => !value?.trim() || numberPresent(value);
    return baselineSizesReady(rows) && rows.every((r) => optionalNumber(r.tolPlus) && optionalNumber(r.tolMinus));
}
/** 完成检查只管当前岗位的产出，不以其他岗位未完工挡住并行录入。 */
export function stageContentIssue(section, stage, sheet) {
    if (section === SHEET_SECTION.DESIGN && (!sheet.stdSize || !sheet.attachments.some((a) => a.kind === ATTACHMENT_KIND.FLAT_SKETCH)))
        return 'server.stageDesignMissing';
    if (section === SHEET_SECTION.PATTERN) {
        if (stage === STAGE.BASE_SIZE_DONE && !baselineSizesReady(sheet.stdSizes))
            return 'server.patternSizeEmpty';
        if (stage === STAGE.SIZE_SPEC_DONE && !sizeDeviationsReady(sheet.stdSizes))
            return 'server.stageDeviationMissing';
    }
    if (section === SHEET_SECTION.MATERIAL) {
        if (stage === STAGE.DESIGNER_DONE && !sheet.colorways.some((c) => c.isUsed))
            return 'submitCheck.noColorway';
        if (stage === STAGE.PRODUCTION_REVIEWED && sheet.materials.some((r) => !numberPresent(r.width) || Number(r.width) <= 0))
            return 'server.stageWidthMissing';
        if (stage === STAGE.TRIM_TECHNICAL_DONE && sheet.subMaterials.some((r) => !r.subMaterialCd?.trim() || !r.sizes.some((s) => s.isUsed)))
            return 'server.stageTrimMissing';
        if (stage === STAGE.TRIM_TECHNICAL_DONE && sheet.subMaterials.some((r) => !isSewingThread(r) && r.sizes.some((s) => s.isUsed && !numberPresent(s.realYardage ?? s.yardage))))
            return 'server.stageUsageMissing';
        if (stage === STAGE.USAGE_ENTERED && sheet.materials.some((r) => !numberPresent(r.realYardage ?? r.yardage)))
            return 'server.stageUsageMissing';
    }
    return null;
}
//# sourceMappingURL=stage-content.js.map